  <!-- MIGAS DE PAN Y TÍTULO -->
  <empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
  <div class="bg-second-migas">
    <div class="container-fluid mt-cab-fixed">
      <div class="pre-content">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">Poseedores</li>
            <li class="breadcrumb-item">Aportaciones de DI/FS</li>
          </ol>
        </nav>
        <div class="content-title">
          <h2 class="title-pag">Búsqueda Aportaciones de DI/FS</h2>

          <div *ngIf="canAccessNuevoDis() || canAccessCargaMasivaDis()" style="display: flex; align-items: center;">
            <!-- <div *ngIf="(canViewResource('PO-POSEEDOR') && this.nimaPoseedorArray?.length === 0)" data-placement="top" title="">
              <mat-icon class="show-icon"
                matTooltip="Empiece aportando las cantidades de residuos gestionadas y los DI">warning_amber</mat-icon>
            </div> -->
            <button  type="button" class="btn btn-primary" data-toggle="modal"
              matTooltip="Solo se permite un fichero (pdf.) compuesto de varios DIs, con un máximo de 50 DIs. "
              matTooltipPosition="above"
              (click)="openModalContributions(false, true)">Carga aportaciones ficheros multiples</button>
            <button  type="button" class="btn btn-primary" data-toggle="modal"
            matTooltip="Solo se permite un DI/FS por archivo cargado, con un máximo de hasta 20 documentos."
            matTooltipPosition="above" style="margin-left:1.5em;"
              (click)="openModalContributions(false)">Carga aportaciones DI/FS</button>
            <button *ngIf="canAccessNuevoDis()" type="button" class="btn btn-primary" data-toggle="modal"
            matTooltip="Debe cumplimentar los datos de este formulario y subir 1 documento (DI/FS)."
            matTooltipPosition="above" style="margin-left:1.5em;"
              (click)="openModalContributions(true)"><span class="icon-add"></span>Nueva aportación DI/FS</button>
          </div>

        </div>
      </div>
    </div>
  </div>
  <!-- FIN MIGAS DE PAN Y TÍTULO -->
  <!-- CONTENIDO -->

  <div class="container-form">
    <!-- Barra de filtros aplicados -->
    <div class="filtros-bar">
      <div class="filtros-aplicados">
        <span class="filtros-label">Filtros aplicados</span>
        <span *ngFor="let filtro of filtrosAplicados" class="filtro-chip">
          {{filtro.label}}
          <button type="button" class="chip-remove" (click)="quitarFiltro(filtro)">×</button>
        </span>
      </div>
      <button type="button" class="btn-toggle-filtros" (click)="toggleFiltros()">
        <mat-icon>tune</mat-icon>
        {{ mostrarFiltros ? 'Ocultar Filtros' : 'Ver Filtros' }}
      </button>
    </div>
    <!-- Formulario de búsqueda -->
    <form *ngIf="mostrarFiltros" class="container-fluid form-search py-3" [formGroup]="searchForm">
       <div class="d-flex flex-wrap" style="gap: 1rem;">
        <div style="flex: 1 1 300px; max-width: 600px;" *ngIf="tipoAcceso === 'poseedor' || tipoAcceso === 'gestor'">
          <ng-container>
            <label for="poseedor">Poseedor </label>
            <div class="custom-mat-field">
              <mat-form-field class="custom-mat-form-field" appearance="outline" subscriptSizing="dynamic">
                <mat-select formControlName="poseedor" id="poseedor" placeholder="-- Poseedor --" multiple>
                  <mat-option *ngFor="let poseedor of poseedorArray" [value]="poseedor.id">
                    {{ poseedor.nima }} - {{ poseedor.razonSocial }} - {{poseedor.denominacionCentro}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </ng-container>
        </div>
        <div style="flex: 1 1 300px; max-width: 400px; min-width: 0;" *ngIf="canViewResource('PO-ENV-GEST')||canViewResource('PO-ENV-CONS')">
          <label for="poseedor">Razón Social Poseedor - NIMA - Centro</label>
          <div class="custom-mat-field">
            <lib-ge-select-pagination [endPointFilter]="poseedorEndpoint" [multiple]=true [updateList]="updateList"
              [placeHolder]="'--Poseedores--'" [formControlNameSelect]="getFormControl('poseedor')"
              [descripcion]="getPoseedorDescription" [objQueryName]="getPoseedorObjectQuery" 
               [enableTooltip]="true" [tooltip]="getPoseedorDescription">
            </lib-ge-select-pagination>
            
              <!--Actualmente se quiere todos los poseedores [defaultParameters]="defaultPoseedoresParameters"-->
          </div>
        </div>
        <div style="flex: 1 1 150px; max-width: 200px;" *ngIf="canViewResource('PO-ENV-GEST')||canViewResource('PO-ENV-CONS')">
          <label for="idposeedor">ID. Poseedor </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline" subscriptSizing="dynamic">
              <input matInput formControlName="idposeedor" id="idposeedor" placeholder="ID. Poseedor" type="text" (keydown)="onlyNumberKey($event)">
            </mat-form-field>
          </div>
        </div>
       <div style="flex: 1 1 200px; max-width: 300px;"  *ngIf="canViewResource('PO-ENV-GEST')||canViewResource('PO-ENV-CONS')">
          <label for="codigo_documento">Documento poseedor (NIE, NIF) </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline" subscriptSizing="dynamic">
              <input matInput formControlName="codigo_documento" id="codigo_documento"
                placeholder="Documento (NIE, NIF)" type="text">
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 200px; max-width: 300px;" *ngIf="tipoAcceso === 'poseedor' || tipoAcceso === 'gestor'">
          <label for="estado">Estado </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline" subscriptSizing="dynamic">
              <mat-select formControlName="estado" id="estado" placeholder="-- Estado --" multiple>
                <mat-option *ngFor="let des of estadoArray" [value]="des">
                  {{ des.descripcionCorta }}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('estado')" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'estado')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 200px; max-width: 300px;"*ngIf="canViewResource('PO-ENV-GEST')||canViewResource('PO-ENV-CONS')">
          <label for="estadoPoseedor">Estado Poseedor</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline" subscriptSizing="dynamic">
              <mat-select formControlName="estadoPoseedor" id="estadoPoseedor" placeholder="-- Estado Poseedor --" multiple>
                <mat-option *ngFor="let des of estadoPoseedorArray" [value]="des">
                  {{ des.descripcionCorta }}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('estadoPoseedor')" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'estadoPoseedor')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>
                        <div style="flex: 1 1 300px; max-width: 400px; min-width: 0;"*ngIf="canViewResource('PO-ENV-GEST')||canViewResource('PO-ENV-CONS')">
          <label for="gestor">Razón Social Gestor - NIMA - Centro </label>
          <div class="custom-mat-field">
             <lib-ge-select-pagination [endPointFilter]="listaGestores" [multiple]=true [updateList]="updateList"
              [placeHolder]="'-- Gestores --'" [formControlNameSelect]="getFormControl('gestor')"
              [descripcion]="getGestorDescription" [objQueryName]="getGestorObjectQuery" [customClass]="rightHolder('gestor')"
              [defaultParameters]="defaultGestoresParameters" [enableTooltip]="true" [tooltip]="getGestorDescription">
            </lib-ge-select-pagination>
          </div>
        </div>



        <div style="flex: 1 1 150px; max-width: 200px;" *ngIf="canViewResource('PO-ENV-GEST')||canViewResource('PO-ENV-CONS')">
          <label for="nima_gestor">NIMA del gestor </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline" subscriptSizing="dynamic">
              <input matInput formControlName="nima_gestor" id="nima_gestor" placeholder="NIMA del gestor " type="text">
            </mat-form-field>
          </div>
        </div>
                <div style="flex: 1 1 200px; max-width: 300px;"*ngIf="canViewResource('PO-ENV-GEST')||canViewResource('PO-ENV-CONS')">
          <label for="codigo_documento_gestor">Documento gestor (NIE, NIF) </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="codigo_documento_gestor" id="codigo_documento_gestor"
                placeholder="Documento gestor (NIE, NIF)" type="text">
            </mat-form-field>
          </div>
        </div>
                <div style="flex: 1 1 200px; max-width: 300px;" *ngIf="canViewResource('PO-ENV-GEST')||canViewResource('PO-ENV-CONS')">
          <label for="estadoGestor">Estado Gestor</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="estadoGestor" id="estadoGestor" placeholder="-- Estado Gestor --" multiple>
                <mat-option *ngFor="let des of estadoGestorArray" [value]="des">
                  {{ des.descripcionCorta }}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('estadoGestor')" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'estadoGestor')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 180px; max-width: 250px;">
          <label for="fecha_desde">Fecha de aceptación desde <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field appearance="outline" class="custom-mat-form-field" subscriptSizing="dynamic">
              <input matInput [matDatepicker]="datepicker1" formControlName="fecha_desde">
              <mat-datepicker-toggle matIconSuffix [for]="datepicker1"></mat-datepicker-toggle>
              <mat-datepicker #datepicker1>
              </mat-datepicker>
              <mat-error *ngIf="controlHasError('fecha_desde', 'required')">Campo
                obligatorio</mat-error>
              <mat-error *ngIf="controlHasError('fecha_desde', 'matDatepickerParse')">Formato incorrecto</mat-error>
            </mat-form-field>
          </div>

        </div>

        <div style="flex: 1 1 180px; max-width: 250px;">
          <label for="fecha_hasta">Fecha de aceptación hasta <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field appearance="outline" class="custom-mat-form-field" subscriptSizing="dynamic">
              <input matInput [matDatepicker]="datepicker2" formControlName="fecha_hasta">
              <mat-datepicker-toggle matIconSuffix [for]="datepicker2"></mat-datepicker-toggle>
              <mat-datepicker #datepicker2>
              </mat-datepicker>
              <mat-error *ngIf="controlHasError('fecha_hasta', 'required')">Campo
                obligatorio</mat-error>
              <mat-error *ngIf="controlHasError('fecha_hasta', 'matDatepickerParse')">Formato incorrecto</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div style="flex: 1 1 180px; max-width: 250px;">
          <label for="fecha_desde_aport">Fecha aportación desde</label>
          <div class="custom-mat-field">
            <mat-form-field appearance="outline" class="custom-mat-form-field" subscriptSizing="dynamic">
              <input matInput [matDatepicker]="datepicker3" formControlName="fecha_aport_desde">
              <mat-datepicker-toggle matIconSuffix [for]="datepicker3"></mat-datepicker-toggle>
              <mat-datepicker #datepicker3>
              </mat-datepicker>
              <mat-error *ngIf="controlHasError('fecha_aport_desde', 'matDatepickerParse')">Formato incorrecto</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div style="flex: 1 1 180px; max-width: 250px;">
          <label for="fecha_hasta_aport">Fecha aportación hasta</label>
          <div class="custom-mat-field">
            <mat-form-field appearance="outline" class="custom-mat-form-field" subscriptSizing="dynamic">
              <input matInput [matDatepicker]="datepicker4" formControlName="fecha_aport_hasta">
              <mat-datepicker-toggle matIconSuffix [for]="datepicker4"></mat-datepicker-toggle>
              <mat-datepicker #datepicker4>
              </mat-datepicker>
              <mat-error *ngIf="controlHasError('fecha_aport_hasta', 'matDatepickerParse')">Formato incorrecto</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 530px; max-width: 800px;">
          <label for="codigoLer">Codigo Ler y Descripción</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="codigoLer" id="codigoLer" placeholder="-- Codigo Ler y Descripción --" multiple>
                <mat-option *ngFor="let des of codigoLerArray" [value]="des">
                  {{ des.tipoCodigo }} - {{ des.descripcion }}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('codigoLer')" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'codigoLer')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 300px; max-width: 400px;">
          <label for="operacionGestion">Operación de Gestión y Descripción</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="operacionGestion" id="operacionGestion" placeholder="-- Operación de Gestión y Descripción --" multiple>
                <mat-option *ngFor="let des of operacionGestionArray" [value]="des">
                  {{ des.codigo }} - {{ des.descripcion }}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('operacionGestion')" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'operacionGestion')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>

        <div style="flex: 1 1 200px; max-width: 300px;" *ngIf="canViewResource('PO-ENV-GEST')||canViewResource('PO-ENV-CONS')">
          <label for="estado">Estado aportación </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline" subscriptSizing="dynamic">
              <mat-select formControlName="estado" id="estado" placeholder="-- Estado aportación --" multiple>
                <mat-option *ngFor="let des of estadoArray" [value]="des">
                  {{ des.descripcionCorta }}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('estado')" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'estado')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm flex-grow-1">
          <label for="doc_identificacion">Doc. Identificación/Full Seguiment </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline" subscriptSizing="dynamic">
              <input matInput formControlName="doc_identificacion" id="doc_identificacion"
                placeholder="Doc. Identificación/Full Seguiment " type="text">
              <mat-error *ngIf="controlHasError('doc_identificacion', 'minlength')">Mínimo 6 caracteres</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 200px; max-width: 300px;" *ngIf="canViewResource('PO-ENV-GEST')||canViewResource('PO-ENV-CONS') || tipoAcceso === 'poseedor'">
          <label for="origen">Origen </label>
            <mat-form-field class="custom-mat-form-field" appearance="outline" subscriptSizing="dynamic">
              <mat-select formControlName="origen" id="origen" placeholder="-- Origen --" multiple>
                <mat-option *ngFor="let origen of origenArray" [value]="origen.value">
                  {{origen.label}}
                </mat-option>
              </mat-select>
           <!--<span *ngIf="showClearButton('origen')" tabindex="0" class="ng-clear-wrapper"
                    (click)="clearSelection($event,'origen')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>-->

            </mat-form-field>
        </div>
          
        <div style="flex: 1 1 200px; max-width: 300px;" *ngIf="mostrarPlataformaOrigen">
          <label for="plataformaOrigen">Plataforma origen </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline" subscriptSizing="dynamic">
              <mat-select formControlName="plataformaOrigen" id="plataformaOrigen" placeholder="-- Plataforma origen --" multiple>
                <mat-option *ngFor="let des of plataformaOrigenArray" [value]="des">
                  {{ des.descripcion }}
                </mat-option>
              </mat-select>
              <!--<span *ngIf="showClearButton('plataformaOrigen')" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'plataformaOrigen')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>-->
            </mat-form-field>
          </div>
        </div>

        <div style="flex: 1 1 150px; max-width: 200px;">
          <label for="cargadoPor">Cargado por </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline" subscriptSizing="dynamic">
              <mat-select formControlName="cargadoPor" id="cargadoPor" placeholder="-- Cargado por --">
                <mat-option *ngFor="let cargadoPor of cargadoPorArray" [value]="cargadoPor.id">
                  {{cargadoPor.name}}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('cargadoPor')" tabindex="0" class="ng-clear-wrapper"
                    (click)="clearSelection($event,'cargadoPor')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>

        <div style="flex: 1 1 150px; max-width: 200px;" *ngIf="(canViewResource('PO-ENV-GEST')||canViewResource('PO-ENV-CONS'))">
          <label for="cantidadDesde">Cantidad (Kg) desde </label>
          <div class="custom-mat-field">
            <mat-form-field appearance="outline" class="custom-mat-form-field" subscriptSizing="dynamic">
            <input matInput formControlName="cantidadDesde" id="cantidadDesde" type="text">
            </mat-form-field>
          </div>
        </div>
         <div style="flex: 1 1 150px; max-width: 200px;" *ngIf="(canViewResource('PO-ENV-GEST')||canViewResource('PO-ENV-CONS'))">
          <label for="cantidadHasta">Cantidad (Kg) hasta </label>
          <div class="custom-mat-field">
            <mat-form-field appearance="outline" class="custom-mat-form-field" subscriptSizing="dynamic">
            <input matInput formControlName="cantidadHasta" id="cantidadHasta" type="text">
            </mat-form-field>
          </div>
        </div>
      <div style="flex: 1 1 200px; max-width: 200px;" *ngIf="canViewResource('PO-ENV-GEST')||canViewResource('PO-ENV-CONS')" >
          <label for="orden">Orden</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="orden" id="orden" placeholder="Seleccionar" multiple>
         <mat-option *ngFor="let item of orden" [value]="item.codigo">
                  {{item.descripcionCorta}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 200px; max-width: 200px;" *ngIf="canViewResource('PO-ENV-GEST')||canViewResource('PO-ENV-CONS')" >
          <label for="tipoOrden">Tipo de orden</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="tipoOrden" id="tipoOrden" placeholder="Seleccionar">
<mat-option [value]="'ASC'">Ascendente</mat-option>
                <mat-option [value]="'DESC'">Descendente</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

    </form>
        <form class="container-fluid form-search py-3">
    <div class="button-group">
      <button type="button" class="btn btn-outline-primary" (click)="clearSearcher()">Limpiar</button>
      <button type="button" class="btn btn-primary" (click)="searchData()">Buscar</button>
    </div>
  </form>
    <!-- FIN Formulario de búsqueda -->
  </div>
  <div class="bg-second-table-info pt-3 pb-5">
    <div *ngIf="flagSearch; else messageClear" class="container-fluid">
      <div class="actions-table">
        <div class=""><span class="align-middle tit-table" style="color: #080C35;">{{ recordsTotal }} registros encontrados</span><span *ngIf="totalKilos !== undefined" class="align-middle tit-table" style="margin-left: 1.5rem; color: #080C35;">Total Kg gestionados: <strong>{{ totalKilos | number:'1.2-2':'es-ES' }}</strong></span></div>
        <div class="text-right">
          <div class="d-inline">

            <div class=" d-flex d-inline dropdown show">
              <button *ngIf="canAccessCrearAutoFactura()" type="button" class="btn btn-primary margin-bton-auto"
                data-toggle="modal" (click)="crearAutoFactura()"><span class="icon-add"></span>Crear
                Prefactura</button>
              <a (click)="confirmarBottonExportar()" class="btn btn-outline-primary" role="button" aria-haspopup="true"
                aria-expanded="false">
                <span class="mr-3">Exportar</span></a>
            </div>
          </div>
        </div>
      </div>

      <div class="card-tabla-proy">
        <div class="card-body">
          <div class="datatable-wrapper datatable-loading no-footer sortable searchable fixed-columns">
            <div class="datatable-container table-responsive">
              <!-- TABLA Listado con resultados de búsqueda -->
              <lib-ge-table [headArray]="headArray" [gridArray]="gridArray" (checked)="checked($event)"
                (allChecked)="selectAll($event)" (actionButton)="action($event)"></lib-ge-table>
              <div class="d-flex pb-2 flex-row justify-content-center align-items-center">
                <div class="d-flex mt-2">
                  <ngb-pagination [pageSize]="pageSize" [collectionSize]="recordsTotal" [(page)]="pageNumber"
                    (pageChange)="renderPage($event)" [maxSize]="5" aria-label="Default pagination" size="sm">
                  </ngb-pagination>
                </div>

                <div class="mt-2 selectPage">
                  <label for="itemsPerPage">Mostrar:</label>
                  <select id="itemsPerPage" [(ngModel)]="selectedItemsPerPage" (change)="onItemsPerPageChange()">
                    <option *ngFor="let option of itemsPerPageOptions" [value]="option">{{ option }}</option>
                  </select>
                </div>
              </div>
              <!-- FIN TABLA Listado con resultados de búsqueda -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-template #messageClear>
      <div class="mensaje-container">
        <p class="mensaje-linea">No hay resultados de búsqueda, por favor seleccione, al menos, un criterio en el
          formulario</p>
        <p class="mensaje-linea"></p>
      </div>
    </ng-template>
  </div>
